module.exports = __webpack_public_path__ + "img/cartracalivre.d70afa7d.webp";